
export const wsbase = 'https://ws.ourvoiceusa.org';




// WEBPACK FOOTER //
// ./src/config.js